module.exports = __webpack_public_path__ + "img/total-3.f6c03cc8.png";